import { API_ENDPOINTS, API_HEADERS } from '../constants/api';

export interface SubscriptionPayload {
  email: string;
}

export const submitSubscription = async (email: string): Promise<void> => {
  const response = await fetch(API_ENDPOINTS.subscription, {
    method: 'POST',
    headers: API_HEADERS,
    body: JSON.stringify({ email }),
  });

  if (!response.ok) {
    throw new Error(`Subscription request failed with status ${response.status}`);
  }
};

